<div class="modal">
	<div [ngClass]="'modal-body'+(large?'-'+large : '')" [draggable]="movible">
		<header>
			<h3>{{title}}</h3>
			<button type="button" class="modal_close" (click)="modalService.closeById(id)">
				<i class="fas fa-times"></i>
			</button>
		</header>
		<hr><br>
		<ng-content></ng-content>
	</div>
</div>
<div class="modal-background"></div>